import moment from 'moment';
import * as firebaseHelpers from '../helpers/Firebase/';
import * as apiHelpers from '../helpers/API/';
import * as types from './actionTypes';

export function loadBalance() {
  return async dispatch => {
    const merchantBalance = await apiHelpers.getMerchantBalance();

    dispatch({
      type: types.SET_BALANCE,
      merchantBalance,
    });
  };
}

export function loadTransactions() {
  return (dispatch, getState) =>
    // eslint-disable-next-line no-async-promise-executor
    new Promise(async resolve => {
      const user = await firebaseHelpers.getCurrentUser(false);
      const { accountType } = getState().userReducer;
      const { selectedGivingOrganization } = getState().dashboardReducer;

      if (user) {
        const userBasePath = accountType === 0 ? `organizations/${user.uid}` : `users/${user.uid}`;

        firebaseHelpers.watchCollectionChanges(
          `${userBasePath}/transactions`,
          transactions => {
            transactions = transactions.sort((a, b) => {
              if (a.date === b.date) {
                return 0;
              } else if (a.date > b.date) {
                return -1;
              } else if (a.date < b.date) {
                return 1;
              }
            });
            transactions = transactions.map(({ date, ...other }) => ({
              date,
              ...other,
              date_formatted: moment(date).format('MMM DD YYYY'),
            }));

            if (accountType === 1 && selectedGivingOrganization) {
              transactions = transactions.filter(({ organization }) => selectedGivingOrganization.id === organization);
            }
            dispatch({
              type: types.LOAD_TRANSACTIONS,
              transactions,
            });
            resolve();
          }
        );
      }
    });
}
